module.exports = __webpack_public_path__ + "static/media/48274918_2308804682528043_4252939112568324096_o-thumb.4fbdc8cb.jpg";